export enum ErrorTypes {
  "isRequired",
  "isNotValid",
}

export type ErrorValue = {
  field?: string;
  errorType: ErrorTypes;
  message: string;
};

export type NameError = {
  first_name?: ErrorValue[];
  middle_name?: ErrorValue[];
  last_name?: ErrorValue[];
};
export type AddressError = { state?: ErrorValue[]; zip_code?: ErrorValue[] };
export type DegreeError = {
  name?: ErrorValue[];
  educator?: ErrorValue[];
  country?: ErrorValue[];
  start_date?: ErrorValue[];
  end_date?: ErrorValue[];
};
export type JobsError = {
  title?: ErrorValue[];
  employer?: ErrorValue[];
  country?: ErrorValue[];
  start_date?: ErrorValue[];
  end_date?: ErrorValue[];
};
export type PersonFormStateError = {
  birth_date?: ErrorValue;
  blueprint_uuid?: ErrorValue;
  company?: ErrorValue;
  names?: NameError;
  jobs?: JobsError;
  addresses?: AddressError;
  degrees?: DegreeError;
  phones?: ErrorValue[];
  emails?: ErrorValue[];
  profiles?: ErrorValue[];
};
